import {useProductLists, WISH_LIST_TYPE} from './use-product-lists'

/** @param {{ listId?: string }} [options] */
export const useWishlistData = ({listId = ''} = {}) => {
    const productLists = useProductLists()

    const {allLists, wishList, customFolders, refetch, isLoading, queryEnabled, ...rest} =
        productLists

    const wishlist = listId
        ? allLists.find((list) => list.id === listId && list.type === WISH_LIST_TYPE) ?? null
        : wishList

    return {
        wishlist,
        refetchWishlist: refetch,
        isWishlistLoading: isLoading,
        allLists,
        customFolders,
        refetchAllLists: refetch,
        queryEnabled,
        productListsQuery: {...rest, allLists, wishList, customFolders, refetch, isLoading, queryEnabled}
    }
}
